export type Group = {
  id: number;
  type: 'public' | 'private';
  name: string;
  description: string;
  code: string;
  entry_code?: string | null;
  latest_members: Member[];
  member_count: number;
  competitions_count: number;
  joined: boolean;
  notifications: 0 | 1;
};

export enum GroupRole {
  MEMBER = 1,
  MANAGER = 2,
}

export type Member = {
  id: number;
  name: string;
  photo?: Media;
  status: 'joined' | 'invited';
  role: GroupRole;
};

export type GroupsFilter = 'all' | 'mine';
